import React, { Component } from 'react';
import Form from 'react-bootstrap/Form';
import PlacesAutocomplete from 'react-places-autocomplete';

export default class FormAddress extends Component {
    render() {
        const searchOptions = {
            componentRestrictions: {
                country: ['ca']
            }
        }
        return (
            <div className="ridepage__features__item">
                {this.props.getIcon("address")}
                <span className="ridepage__feature__item__title"> Address </span>
                <span className="ridepage__feature__item__detail">
                    <Form.Group controlId="formGridAddress1">
                        <PlacesAutocomplete
                            searchOptions={searchOptions}
                            value={this.props.address}
                            onChange={this.props.onAddressChange}
                        >
                            {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
                                <div>
                                    <Form.Control
                                        name="address"
                                        required
                                        {...getInputProps({
                                            placeholder: 'Adresse de la balade',
                                            className: 'location-search-input',
                                        })}
                                    />
                                    <div className="autocomplete-dropdown-container">
                                        {loading && <div>Loading...</div>}
                                        {suggestions.map(suggestion => {
                                            const className = suggestion.active
                                                ? 'suggestion-item--active'
                                                : 'suggestion-item';
                                            // inline style for demonstration purpose
                                            const style = suggestion.active
                                                ? { backgroundColor: '#fafafa', cursor: 'pointer' }
                                                : { backgroundColor: '#ffffff', cursor: 'pointer' };
                                            return (
                                                <div
                                                    {...getSuggestionItemProps(suggestion, {
                                                        className,
                                                        style,
                                                    })}
                                                >
                                                    <span>{suggestion.description}</span>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            )}
                        </PlacesAutocomplete>
                    </Form.Group>
                </span>
            </div>
        )
    }
}